import { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { SystemMsg } from "../../utils/SystemMsg";
import logo from "../../logo.png";
import { useI18n } from "../../i18n";
function ForgotPasswordModal({ show, onResetButtonClick, onClose }) {
  const { t } = useI18n();
  const title = t("login.forgotPassword");
  const [email, setEmail] = useState(null);
  const [emailInvalidMsg, setEmailInvalidMsg] = useState(
    SystemMsg.Login.email_invalid
  );

  const handleClose = (triggerCustomFunc = true) => {
    if (typeof onClose === "function") {
      if (triggerCustomFunc) {
        onClose();
      }
    }
    setEmail(null);
  };

  const handleSaveButtonClick = () => {
    if (!email) {
      setEmail("");
      return;
    }
    const emailOk = /^\S+@\S+\.\S+$/.test(email);
    if (emailOk) {
      const dataObj = {
        email: email,
      };
      if (typeof onResetButtonClick === "function") {
        onResetButtonClick(dataObj);
      }
    }
    handleClose(false);
  };

  const emailOnChange = (event) => {
    setEmail(event.target.value);
  };

  return (
    <>
      <Modal
        size="md"
        centered={true}
        show={show}
        onHide={handleClose}
        backdrop="static"
        dialogClassName="modal-30w"
      >
        <Modal.Header style={{ border: "none" }} closeButton>
          <Modal.Title>
            <img
              alt="App Logo"
              src={logo}
              style={{
                width: "25px",
                userSelect: "none",
                display: "inline-block",
                marginRight: "10px",
                marginTop: "-5px",
              }}
            />
            <span>{title}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="forgotPasswordModal.email">
              {/* <Form.Label>Email</Form.Label> */}
              <Form.Control
                type="text"
                placeholder={t("fields.email")}
                value={email}
                onChange={emailOnChange}
                isInvalid={email !== null && !/^\S+@\S+\.\S+$/.test(email)}
                required
                autoFocus
              />
              <Form.Control.Feedback type="invalid">
                {emailInvalidMsg}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleSaveButtonClick}>
            {t("login.resetPassword")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ForgotPasswordModal;
